<template>
  <ProductsGrid
    v-if="mawProducts && !loadingProductsList"
    :title="$t('Discover Products')"
    layout="row"
    :products="mawProducts"
    grid-id="discover-products"
  />
</template>
<script>
import ProductsGrid from '~/components/Catalog/ProductsGrid.vue';
import { defineComponent, ref, useFetch } from '@nuxtjs/composition-api';
import { useProduct } from '@gemini-vsf/composables';

export default defineComponent({
  name: 'EditorialProductCarousel',
  components: { ProductsGrid },
  props: {
    categoryUid: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const {
      search,
      products: searchResult,
      loading: loadingProductsList,
    } = useProduct('mawProduct');
    const mawProducts = ref();

    useFetch(async () => {
      const baseSearchQuery = {
        pageSize: 20,
        filter: {
          category_uid: {
            eq: `grn:product-list:product-list::${props.categoryUid}`,
          },
        },
      };
      await search({
        queryType: 'LIST',
        ...baseSearchQuery,
        customQuery: {
          products: 'productListCustom',
        },
      });

      mawProducts.value = searchResult.value?.items ?? [];
    });
    return {
      mawProducts,
      loadingProductsList,
    };
  },
});
</script>
